module.exports = __webpack_public_path__ + "img/3.d0bb8723.png";